// Custom line-art motifs for brand symbolism (lotus, lighthouse, loft)
import React from "react";

export const LotusIcon = ({ className = "", stroke = "currentColor", strokeWidth = 1.2 }) => (
  <svg viewBox="0 0 64 64" className={className} fill="none" stroke={stroke} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
    <path d="M32 14c4 6 5 13 0 22-5-9-4-16 0-22Z" />
    <path d="M32 36c-6-2-12-1-17 3 5 5 12 6 17 2" />
    <path d="M32 36c6-2 12-1 17 3-5 5-12 6-17 2" />
    <path d="M32 36c-3-5-9-9-16-9 1 7 6 12 12 13" />
    <path d="M32 36c3-5 9-9 16-9-1 7-6 12-12 13" />
    <path d="M16 42c5 6 11 8 16 8s11-2 16-8" opacity="0.5" />
  </svg>
);

export const LighthouseIcon = ({ className = "", stroke = "currentColor", strokeWidth = 1.2 }) => (
  <svg viewBox="0 0 64 64" className={className} fill="none" stroke={stroke} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
    <path d="M26 24h12l3 26H23l3-26Z" />
    <path d="M24 33h16M23 42h18" />
    <path d="M27 24v-4h10v4" />
    <path d="M29 20h6l-1-4h-4l-1 4Z" />
    <path d="M32 16v-4" />
    <path d="M41 22l7-3M23 22l-7-3M44 30l6 0M20 30l-6 0" opacity="0.55" />
    <path d="M23 54h18" />
  </svg>
);

export const LoftIcon = ({ className = "", stroke = "currentColor", strokeWidth = 1.2 }) => (
  <svg viewBox="0 0 64 64" className={className} fill="none" stroke={stroke} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 50V26l20-12 20 12v24" />
    <path d="M12 50h40" />
    <path d="M26 50V36h12v14" />
    <path d="M20 28v8M44 28v8" opacity="0.6" />
  </svg>
);

export const LeafIcon = ({ className = "", stroke = "currentColor", strokeWidth = 1.2 }) => (
  <svg viewBox="0 0 64 64" className={className} fill="none" stroke={stroke} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
    <path d="M48 16C28 16 16 28 16 48c20 0 32-12 32-32Z" />
    <path d="M22 42C30 34 38 30 46 28" />
  </svg>
);

export const CrownIcon = ({ className = "", stroke = "currentColor", strokeWidth = 1.2 }) => (
  <svg viewBox="0 0 64 64" className={className} fill="none" stroke={stroke} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 44 12 24l10 8 10-16 10 16 10-8-2 20H14Z" />
    <path d="M14 44h36" />
    <circle cx="12" cy="22" r="2" /><circle cx="52" cy="22" r="2" /><circle cx="32" cy="16" r="2" />
  </svg>
);

export const Motif = ({ name, className, stroke, strokeWidth }) => {
  const map = {
    lotus: LotusIcon,
    lighthouse: LighthouseIcon,
    loft: LoftIcon,
    leaf: LeafIcon,
    crown: CrownIcon,
  };
  const Cmp = map[name] || LotusIcon;
  return <Cmp className={className} stroke={stroke} strokeWidth={strokeWidth} />;
};
